import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo';
import SectionFour from '../components/section-four/SectionFour'
import './about.css';
import img from '../assets/boy.jpg';
import SectionFive from '../components/section-five/SectionFive';
import CardThree from '../components/card-three/CardThree';
import dot from '../assets/dot-2.jpg';
import customer from '../assets/customer-satisfaction.png';
import integrity from '../assets/integrity.png';
import learn from '../assets/learning-icon.png';
import respect from '../assets/respect.png';
import excellence from '../assets/excellence.webp';
import avatar from '../assets/Nwankwo_Uayemen.png';

function About() {
    return (
        <div className='about__container'>
            <HeroTwo 
            head='About Us'
            image={img}
            />
            <div className="about__main">
        <div className="about__mid">
            <img className="dot__img" src={dot} alt="" />
            <SectionFour 
            heading ='We are a team of creators & innovators'
            text='Charis coding club was founded in 2020. The mission of the company is to make programming fun, engaging and attractive for children worldwide. The Vision of the club is to raise the next generation of tech-savy individuals who are ready to compete globally in today`s fast moving digital age.'
            />
        </div>
            <SectionFive />
        <div className="about__card">
            <CardThree 
            head='Customer Satisfaction'
            text='Customer satisfaction to both parents and students' 
            image={customer}
            />
            <CardThree 
            head='Excellence'
            text='We pursue Excellence always'
            image={excellence}
            />
            <CardThree 
            head='Integrity'
            text='We act with integrity'
            image={integrity}
            />
            <CardThree  
            head='Respect'
            text='We respect every individual'
            image={respect}
            />
            <CardThree 
            head='Learning'
            text='We are constantly learning and improving'
            image={learn}
            />
        </div>
        <div className="about__mid reverse">
            <img className="dot__img" src={dot} alt="" />
          
            <div className="sectionFour__main">
            <div className="sectionFour">
            <div className="sectionFour__right">
                    <img data-aos='zoom-in-down'  src={avatar} alt=""/>
                </div>
                <div className="sectionFour__left">
                    <h1  data-aos='zoom-out-down' className="head__one">Meet our Founder</h1>
                    <p data-aos='fade-down'  className="paragraph">A first class graduate of Computer Science from the premier University in Nigeria, University of Ibadan, Uayemen Nwankwo also holds an MBA from Heriot-Watt University, Edinburgh, Scotland and several other qualifications and certifications including a Postgraduate Diploma in Education from Nottingham University, United Kingdom. Uayemen has over 13 years of IT experience. She has worked with some of the major telecommunications companies in Nigeria (Globacom, Etisalat and Huawei Technologies Limited). She is passionate about transferring technological skills to the next generation and believes every child has so much hidden potentials that must be unlocked. </p>
                   
                </div>
                
        </div>
       </div>
          
          
        </div>
            </div>

        </div>
    )
}

export default About
